<iframe [src]="safeUrl" width="305" height="305" frameborder="0" allowfullscreen></iframe>